import BeforeDrivingList from './StartYourBooking/BeforeDrivingList';
import DriverAccident from './AccidentsAndInsurance/DriverAccident';
import FlatTire from './DrivesharingPolicies/FlatTire';
import ChargePolicy from './DrivesharingPolicies/ChargePolicy';
import CarNotInSpot from './DrivesharingPolicies/CarNotInSpot';
import CancelBooking from './MakingABooking/CancelBooking';
import ParkingHubKing from './ParkingHub/King/ParkingHub';
import ParkingHubBloor from './ParkingHub/Bloor/ParkingHub';
import RidesharingApp from './General/RidesharingApp';
import Benefits from './General/Benefits';
import WhenBook from './General/WhenBook';
import InsurancePolicyCoverage from './General/InsurancePolicyCoverage';
import Required from './Eligibility/Required';
import AutzuAccount from './SignUp/AutzuAccount';
import LocationService from './SignUp/LocationService';
import MakeBooking from './MakingABooking/MakeBooking';
import BookingDetails from './MakingABooking/BookingDetails';
import BringToBooking from './MakingABooking/BringToBooking';
import IncidentReport from './StartYourBooking/IncidentReport';
import TrafficViolation from './DrivesharingPolicies/TrafficVoilation';
import VehicleIssue from './VehicleIssues.js/VehicleIssue';
import InsuranceCoverage from './AccidentsAndInsurance/InsuranceCoverage';
import TripRequest from './AccountIssues/TripRequest';
import Suspended from './AccountIssues/Suspended';
import CommunitySafe from './SafetySupport/CommunitySafe';
import ContactUs from './ContactUs/index';
import {
  Cancellation,
  FindCar,
  UnlockCar,
  ExtendBooking,
  EndBooking,
  FeeTable,
  EmergencyFlatTire,
  OpenCloseLock,
  Autzu,
  Drivesharing,
  Ridesharing,
  VehicleType,
  TimeSlot,
  PaymentWork,
  PersonalUse,
  OthersDrive,
  PTCLicense,
  OtherLicense,
  UpfrontFee,
  Approval,
  RideshareAccount,
  ConnectRideshareAcc,
  WithoutAccount,
  Recharge,
  ReturnVehicle,
  Discounts,
  ReferralBonus,
  OpenDoor,
  StartElectric,
  ChangeGears,
  AdjustWheel,
  OpenTrunk,
  HarzardLights,
  ClimateControl,
  RegenerativeBraking,
  LowBatteryLevel,
  NearestSupercharger,
  PaySupercharging,
  SuperchargerIdleFee,
  StartBookingTutorial,
  EndBookingTutorial
} from './HelpFunctions';

import AutzuEVDataAll from './StartVehicleData/AutzuEVData/AutzuEVDataAll';
import ChargingTime from './DrivesharingPolicies/ChargingTime';
import ChargingCost from './DrivesharingPolicies/ChargeCost';
import ChargeTesla from './DrivesharingPolicies/ChargeTesla';
import HourlyRate from './General/HourlyRate';
import WhatisAutzuEV from './General/WhatIsAutzuEV';
import VehicleAvailable from './General/VehicleAvailable';
import RechargeVehicleCost from './General/RechargeVehicleCost';
import ChangeHub from './ParkingHub/ChangeHub';
import CostLessThanInsuranceDeductible from './AccidentsAndInsurance/CostLessThanInsuranceDeductible';

export const driverFaqData = [
  {
    heading: 'General',
    content: [
      {
        title: 'What is Autzu?',
        info: [{ component: Autzu }]
      },
      {
        title: 'What is drivesharing?',

        info: [{ component: Drivesharing }]
      },
      {
        title: 'What is ridesharing?',
        info: [{ component: Ridesharing }]
      },
      {
        title: 'Which ridesharing apps can I use with Autzu?',
        info: [{ component: RidesharingApp }]
      },
      {
        title: 'What types of vehicles can I drive?',
        info: [{ component: VehicleType }]
      },
      {
        title: 'What is the booking rate and what is included?',
        info: [{ component: HourlyRate }]
      },
      {
        title: 'What are the benefits of driving with Autzu?',
        info: [{ component: Benefits }]
      },
      {
        title: 'When can I drive?',
        info: [{ component: WhenBook }]
      },
      {
        title: 'Can I book in advance?',
        info: [{ component: TimeSlot }]
      },
      {
        title: 'How does payment work?',
        info: [{ component: PaymentWork }]
      },
      {
        title: 'What is your cancellation policy?',
        info: [{ component: Cancellation }]
      },
      {
        title: 'Can I use Autzu vehicles for personal use?',
        info: [{ component: PersonalUse }]
      },
      {
        title:
          'Can I let someone else drive an Autzu vehicle using my account?',
        info: [{ component: OthersDrive }]
      },
      {
        title: 'What does the insurance policy cover?',
        info: [{ component: InsurancePolicyCoverage }]
      },
      {
        title: 'What is a reduced insurance deductible plan?',
        info: [
          {
            text:
              "For just an additional 60 cents per hour of your booking, you can opt for the reduced insurance deductible plan. This plan is specifically created to lower your deductible in case of an accident. By choosing this plan, you significantly reduce the out-of-pocket amount you'd be responsible for in the event of an incident. It offers you extra financial security and greater peace of mind during your vehicle usage."
          }
        ]
      },
      {
        title: 'What is Autzu EV?',
        info: [{ component: WhatisAutzuEV }]
      },
      {
        title: 'What types of vehicles can I drive',
        info: [{ component: VehicleAvailable }]
      },
      {
        title: 'How much does it cost to recharge the vehicle?',
        info: [{ component: RechargeVehicleCost }]
      }
    ]
  },

  {
    heading: 'Eligibility',
    content: [
      {
        title: 'What is required from me to be able to drive with Autzu?',
        info: [{ component: Required }]
      },
      {
        title: 'What is a PTC license?',

        info: [{ component: PTCLicense }]
      },
      {
        title:
          'Can I drive Autzu if I have an international/out of province license?',
        info: [{ component: OtherLicense }]
      }
    ]
  },
  {
    heading: 'Signing up',
    content: [
      {
        title: 'Do I have to pay any upfront fees or security deposits?',
        info: [{ component: UpfrontFee }]
      },
      {
        title: 'How do I set up an Autzu account?',

        info: [{ component: AutzuAccount }]
      },
      {
        title: 'How soon can I begin driving?',
        info: [{ component: Approval }]
      },
      {
        title: 'How do I set up a rideshare driver account?',
        info: [{ component: RideshareAccount }]
      },
      {
        title: 'Why do I need to connect my rideshare driver account?',
        info: [{ component: ConnectRideshareAcc }]
      },
      {
        title:
          'Can I drive with Autzu without a rideshare driver account connected?',
        info: [{ component: WithoutAccount }]
      },
      {
        title:
          'Why do I have to enable Location Services Notifications, and Cellular Data?',
        info: [{ component: LocationService }]
      }
    ]
  },
  {
    heading: 'Making a booking',
    content: [
      {
        title: 'How do I make a booking?',
        info: [{ component: MakeBooking }]
      },
      {
        title: 'How do I view my booking details?',

        info: [{ component: BookingDetails }]
      },
      {
        title: 'What do I need to bring to the booking?',
        info: [{ component: BringToBooking }]
      },
      {
        title: 'How do I cancel my booking?',
        info: [{ component: CancelBooking }]
      }
    ]
  },
  {
    heading: 'Drivesharing Policies',
    content: [
      {
        title: 'Charging Policy',
        info: [{ component: ChargePolicy }]
      },
      {
        title: 'How long does it take to charge the Tesla?',
        info: [{ component: ChargingTime }]
      },
      {
        title: 'How much does it cost to charge the Tesla?',
        info: [{ component: ChargingCost }]
      },
      {
        title: 'How do I charge the Tesla?',
        info: [{ component: ChargeTesla }]
      },
      {
        title: 'Late Policy',
        info: [{ component: CarNotInSpot }]
      },
      {
        title: 'Damage Policy',
        info: [{ component: FlatTire }]
      },
      {
        title: 'Damage Fee Table',
        info: [{ component: FeeTable }]
      },
      {
        title: 'Traffic Violations and Tolls',
        info: [{ component: TrafficViolation }]
      }
    ]
  },
  {
    heading: 'Finding the Parking Hub',
    content: [
      {
        title: '621 King Street West',
        info: [{ component: ParkingHubKing }]
      },
      {
        title: '280 Bloor Street West',
        info: [{ component: ParkingHubBloor }]
      },
      {
        title: 'How to change your booking from one hub to another:',
        info: [{ component: ChangeHub }]
      }
    ]
  },
  {
    heading: 'Starting your Booking',
    content: [
      {
        title: 'Start booking tutorial',
        info: [{ component: StartBookingTutorial }]
      },
      {
        title: 'How do I find the Autzu vehicle?',
        info: [{ component: FindCar }]
      },
      {
        title: 'How do I start my booking?',
        info: [{ component: UnlockCar }]
      },
      {
        title: 'How do I unlock or lock the vehicle?',
        info: [{ component: OpenCloseLock }]
      },
      // {
      //   title: 'How do I start the vehicle?',
      //   info: [{ component: AutzuEVDataAll }]
      // },
      {
        title: 'How do I open the doors?',
        info: [{ component: OpenDoor }]
      },
      {
        title: 'How do I start the electric motor?',
        info: [{ component: StartElectric }]
      },
      {
        title: 'How do I change gears?',
        info: [{ component: ChangeGears }]
      },
      {
        title: 'How do I adjust the mirrors and steering wheel?',
        info: [{ component: AdjustWheel }]
      },
      {
        title: 'How do I open the trunk or charging port?',
        info: [{ component: OpenTrunk }]
      },
      {
        title: 'How do I turn on the hazard lights?',
        info: [{ component: HarzardLights }]
      },
      {
        title:
          'How do I adjust the climate control or access the windshield wiper controls?',
        info: [{ component: ClimateControl }]
      },
      {
        title:
          'Why does the vehicle brake/slow down when I release the accelerator pedal? What is regenerative braking?',
        info: [{ component: RegenerativeBraking }]
      },
      {
        title: 'What should I do if the vehicle has a low battery level?',
        info: [{ component: LowBatteryLevel }]
      },
      {
        title: 'Where can I find the nearest Tesla Supercharger?',
        info: [{ component: NearestSupercharger }]
      },
      {
        title: 'Who pays for Supercharging?',
        info: [{ component: PaySupercharging }]
      },
      {
        title: 'What are Supercharger idle fees?',
        info: [{ component: SuperchargerIdleFee }]
      },
      {
        title: 'What should I do before driving?',
        info: [{ component: BeforeDrivingList }]
      },
      {
        title: 'How to create a support ticket?',
        info: [{ component: IncidentReport }]
      },
      {
        title: 'Can I extend my booking?',
        info: [{ component: ExtendBooking }]
      }
    ]
  },
  {
    heading: 'Ending your booking',
    content: [
      {
        title: 'End booking tutorial',
        info: [{ component: EndBookingTutorial }]
      },
      {
        title: 'Do I have to recharge the electric vehicle?',
        info: [{ component: Recharge }]
      },
      {
        title: 'Where do I return my Autzu vehicle?',
        info: [{ component: ReturnVehicle }]
      },
      {
        title: 'How do I end my booking?',
        info: [{ component: EndBooking }]
      }
    ]
  },
  {
    heading: 'Vehicle Issues',
    content: [
      {
        title: 'A warning light has come on the dashboard, what do I do?',
        info: [{ component: VehicleIssue }]
      },
      {
        title:
          'I have a flat tire and I am unable to drive. What do I do?',
        info: [{ component: EmergencyFlatTire }]
      }
    ]
  },

  {
    heading: 'Accidents and Insurance',
    content: [
      {
        title: 'I was involved in an accident, what do I do?',
        info: [{ component: DriverAccident }]
      },
      {
        title: 'What does the insurance policy cover?',
        info: [{ component: InsuranceCoverage }]
      },
      {
        title:
          'What happens if the cost of repair is less than the insurance deductible?',
        info: [
          {
            component: CostLessThanInsuranceDeductible
          }
        ]
      },
      {
        title: 'Who decides if I am at-fault for an accident?',
        info: [
          {
            link: {
              leadingText:
                'Ontario Fault Determination Rules (commonly known as the Fault Rules or FDR) is a regulation under the Ontario Insurance Act used to judge driver responsibility after vehicle accidents in Ontario. Learn more ',
              title: 'here',
              href: 'https://www.ontario.ca/laws/regulation/900668',
              trailingText: '.'
            }
          }
        ]
      },
      {
        title:
          'Can I provide an electronic pink insurance slip to third parties or law enforcement?',
        info: [
          {
            link: {
              leadingText:
                'Ontario has approved the use of electronic proof of auto insurance (EPAI) for drivers, effective September 2019 and onwards. This means the pink slip within the Autzu app and other rideshare driver applications is adequate proof of insurance. Simply follow the quick link on your dashboard “Insurance slip” during your reservation to access the digital copy of the insurance slip. Learn more ',
              title: 'here',
              href:
                'https://www.fsrao.ca/industry/auto-insurance-sector/guidance/modernizing-automobile-insurance-approval-electronic-insurance-card',
              trailingText: '.'
            }
          }
        ]
      },
      {
        title: 'Who decides where the Autzu vehicle is repaired?',
        info: [
          {
            text:
              'Autzu will decide where the vehicle will be repaired, using its network of approved repair vendors. You are not permitted to perform any repairs to an Autzu vehicle without prior written consent from Autzu.'
          }
        ]
      },
      {
        title:
          'Am I still able to drive with Autzu after being involved in an accident?',
        info: [
          {
            text:
              'We will investigate the cause of the accident and work with you to process the insurance claim. In most cases, you will be able to continue driving with Autzu.'
          }
        ]
      },
      {
        title:
          'Can I set up a payment plan to cover the insurance deductible or repair cost?',
        info: [
          {
            text:
              'In most cases, we will set up a weekly payment plan to cover the insurance deductible or repair cost, so you can keep driving and earning with Autzu.'
          }
        ]
      },
      {
        title:
          'I think I provided the wrong insurance pink slip to the third party, what should I do?',
        info: [
          {
            text:
              'Contact Autzu immediately and provide us with the correct information so that we can re-submit the claim to the correct insurance company.'
          }
        ]
      }
    ]
  },
  {
    heading: 'Referrals & Rewards',
    content: [
      {
        title: 'Do you offer any discounts?',
        info: [{ component: Discounts }]
      },
      {
        title: 'Do you offer referral bonuses?',
        info: [{ component: ReferralBonus }]
      },
      {
        title: 'How do credits work?',
        info: [
          {
            text:
              'Credits that are applied to your Autzu account can be used towards your next booking, or to pay down your outstanding balance. All credits remain in your Autzu account and do not expire.'
          }
        ]
      }
    ]
  },
  {
    heading: 'Account Issues',
    content: [
      {
        title: 'Why am I not receiving any trip requests?',
        info: [{ component: TripRequest }]
      },
      {
        title:
          'My account is “Suspended”, how do I become “Active” again?',
        info: [{ component: Suspended }]
      },
      {
        title: 'My account is “Blacklisted”, what can I do?',
        info: [
          {
            link: {
              leadingText:
                'Unfortunately, once you have violated either Autzu’s ',
              title: 'Terms & Conditions',
              href: 'https://www.autzu.com/terms',
              trailingText:
                ', your account status will change to Blacklisted. This decision is final and you will no longer be eligible to drive with Autzu.'
            }
          }
        ]
      }
    ]
  },
  {
    heading: 'Safety & Support',
    content: [
      {
        title: 'How do we ensure driver safety?',
        info: [
          {
            text:
              'Our vehicles are fully insured, regularly serviced by certified mechanics, and come with complete service records. '
          },
          {
            text:
              'In case of any unexpected incidents, we have 24/7 roadside assistance and a clear reporting procedure. Our in-car technology keeps an eye on driving behaviour to ensure a safe driving experience for all.'
          }
        ]
      },
      {
        title: 'COVID-19: What is Autzu doing to keep the vehicles safe?',
        info: [
          {
            text:
              'Autzu takes cleanliness seriously and has implemented extra measures, including antiviral solutions, to keep our vehicles hygienic. If we discover a potential virus exposure, we remove the vehicle for a thorough cleaning.'
          }
        ]
      },
      {
        title:
          'COVID-19: What can you do to help keep our community safe?',
        info: [{ component: CommunitySafe }]
      }
    ]
  },
  {
    heading: 'Contact Us',
    content: [
      {
        title: 'I would like to speak to someone. How do I contact Autzu?',
        info: [{ component: ContactUs }]
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/DriverFaqData.js